import ServicePageLayout from '../../components/feature/ServicePageLayout';

const VenetianBlindsPage = () => {
  return (
    <ServicePageLayout
      blindType="Venetian Blinds"
      heroTitle="Venetian Blinds Northampton"
      heroSubtitle="Classic Style with Precise Light Control"
      introText="Enhance your Northampton home with timeless venetian blinds. Featuring horizontal slats that tilt to control light and privacy, venetian blinds offer versatility and style. Available in aluminium, wood and faux wood finishes, they suit any room and décor. Professionally supplied and installed at unbeatable prices."
      heroImage="https://public.readdy.ai/ai/img_res/6b8b30283ccba24d4c5e013f98116d6c.jpg"
      features={[
        { icon: 'ri-contrast-2-line', title: 'Precise Light Control', desc: 'Tilt slats to any angle for perfect control over light and privacy' },
        { icon: 'ri-paint-line', title: 'Multiple Finishes', desc: 'Choose from aluminium, real wood or faux wood in dozens of colours' },
        { icon: 'ri-water-percent-line', title: 'Moisture Resistant Options', desc: 'Aluminium and faux wood venetians are perfect for bathrooms and kitchens' },
        { icon: 'ri-time-line', title: 'Timeless Design', desc: 'Classic horizontal slat style that never goes out of fashion' },
        { icon: 'ri-settings-3-line', title: 'Easy to Adjust', desc: 'Simple cord or wand operation for effortless daily use' },
        { icon: 'ri-home-4-line', title: 'Versatile Application', desc: 'Suitable for every room from living areas to bathrooms' },
      ]}
      pricePerBlind="£109"
      wholeHousePrice="£849"
      benefits={[
        { icon: 'ri-check-line', text: 'Aluminium, wood & faux wood' },
        { icon: 'ri-check-line', text: 'Precise light control' },
        { icon: 'ri-check-line', text: 'Moisture resistant options' },
        { icon: 'ri-check-line', text: 'Professional installation' },
        { icon: 'ri-check-line', text: 'Unbeatable prices' },
      ]}
      faqs={[
        {
          question: 'What is the difference between aluminium and wood venetian blinds?',
          answer: 'Aluminium venetian blinds are lightweight, moisture-resistant and perfect for bathrooms and kitchens. Wood venetian blinds offer natural warmth and elegance, ideal for living rooms and bedrooms. Faux wood combines the look of real wood with moisture resistance.'
        },
        {
          question: 'Are venetian blinds easy to clean?',
          answer: 'Yes! Aluminium and faux wood venetian blinds can be wiped clean with a damp cloth. Wood venetian blinds should be dusted regularly with a soft cloth or duster. All types are low-maintenance and easy to keep looking great.'
        },
        {
          question: 'Can I get venetian blinds for my bathroom?',
          answer: 'Absolutely! We recommend aluminium or faux wood venetian blinds for bathrooms as they are moisture-resistant and won\'t warp or deteriorate in humid conditions.'
        },
        {
          question: 'How do venetian blinds control light?',
          answer: 'Venetian blinds feature horizontal slats that tilt to any angle. You can adjust them to let in filtered light while maintaining privacy, or close them completely for darkness. You can also raise them fully to enjoy an unobstructed view.'
        },
        {
          question: 'What slat widths are available?',
          answer: 'We offer venetian blinds in various slat widths, typically 25mm and 50mm. Narrower slats suit smaller windows, while wider slats create a bolder, more contemporary look on larger windows.'
        },
        {
          question: 'Do venetian blinds provide insulation?',
          answer: 'Yes, when closed, venetian blinds create an insulating layer that helps reduce heat loss in winter and keeps rooms cooler in summer, improving your home\'s energy efficiency.'
        },
      ]}
      additionalContent={
        <section className="py-10 sm:py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
                  Timeless Elegance for Every Northampton Home
                </h3>
                <p className="text-gray-700 mb-6">
                  Venetian blinds have been a popular choice for decades – and it's easy to see why. Their horizontal slat design offers unmatched versatility in controlling light and privacy, while their clean, classic look complements any interior style. Whether you prefer the sleek modern finish of aluminium, the natural warmth of real wood, or the practical beauty of faux wood, venetian blinds deliver style and functionality. Our expert team serves homes across Northampton, providing professional measuring, supply and installation of premium venetian blinds at prices that can't be beaten.
                </p>
              </div>
              <div className="relative rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="https://readdy.ai/api/search-image?query=stylish%20venetian%20blinds%20with%20horizontal%20slats%20in%20elegant%20bedroom%20with%20warm%20wood%20tones%20soft%20filtered%20light%20contemporary%20interior%20design%20no%20people%20professional%20photography&width=800&height=600&seq=venetian-add-001&orientation=landscape"
                  alt="Venetian Blinds in Bedroom"
                  className="w-full h-64 object-cover"
                />
              </div>
            </div>
          </div>
        </section>
      }
    />
  );
};

export default VenetianBlindsPage;